
let clueNumber = 0
let errorCount = 0



export function clueButton_click(event) {
	clueNumber++
	switch (clueNumber){
		case 1:
			$w('#clueButton').label = "לחץ לרמז #2"
			$w('#clueText').text = ""
			$w('#clueText').show()
			break
		case 2:
			$w('#clueButton').label = "לחץ לפתרון"
			$w('#clueText').text = ""
			break
		case 3:
			$w('#clueButton').hide()
			$w('#clueText').text = ""
		}
}

export function submitButton_click(event) {
	let answer = $w('#answerInput').value.toLowerCase()
	let possibleAnswers = ['tulip', 'רחובות']
	if (possibleAnswers.includes(answer)){
		$w('#mainBox').hide("fade").then( () => {
			$w('#mobileImage2').hide()
			$w('#mobileText4').hide()
			$w('#correctAnswerText').show("fade", {delay: 0})
			$w('#correctAnswerText').scrollTo()
		})
	}
	else {
		if (errorCount % 3 === 0){
			$w('#errorSubText').text = 'לא נורא'
		}
		if (errorCount % 3 === 1){
			$w('#errorSubText').text = 'לא להתייאש'
		}
		if (errorCount % 3 === 2){
			$w('#errorSubText').text = 'סומכים עליכם'
		}
		errorCount++
		$w('#errorBox').show("bounce", {direction: "center", delay: 0})
	}
}

export function errorCloseButton_click(event) {
	$w('#errorBox').hide("bounce", {direction: "center", delay: 0})
}